import { gql } from "@apollo/client";

export const FETCH_CUSTOMERS_FOR_SALES_REPORT = gql`
  query FETCH_CUSTOMERS_FOR_SALES_REPORT {
    customers(connectedToOdoo: true) {
      id
      name
      system
      odooPartnerId
    }
  }
`;

export const FETCH_CUSTOMER_INFO_FOR_SALES_REPORT = gql`
  query FETCH_CUSTOMER_INFO_FOR_SALES_REPORT(
    $instance: String!
    $useType: String!
    $odooPartnerIds: [Int]
    $odooPartnerId: Int
  ) {
    odooCustomers(instance: $instance, useType: $useType, ids: $odooPartnerIds)
    customer(odooPartnerId: $odooPartnerId) {
      id
      name
      priceList {
        id
        currency
        name
      }
      documents {
        id
        uri
      }
      reportData
    }
  }
`;

export const SAVE_CUSTOMER_REPORT_DATA = gql`
  mutation SAVE_CUSTOMER_REPORT_DATA($id: ID!, $reportData: String) {
    updateCustomer(id: $id, reportData: $reportData) {
      customer {
        id
        reportData
      }
    }
  }
`;

export const FETCH_PRODUCT_SALES_REPORT = gql`
  query FETCH_PRODUCT_SALES_REPORT(
    $startYear: Int!
    $endYear: Int!
    $currency: String!
    $reportType: String
    $partnerId: Int
  ) {
    odooAbSalesReportProducts(
      startYear: $startYear
      endYear: $endYear
      reportType: $reportType
      currency: $currency
      partnerId: $partnerId
    )
  }
`;

export const FETCH_CUSTOMER_PAYMENT_TIME = gql`
  query FETCH_CUSTOMER_PAYMENT_TIME(
    $partnerId: Int!
    $startYear: Int!
    $endYear: Int!
  ) {
    odooCustomerPaidInvoices(
      partnerId: $partnerId
      startYear: $startYear
      endYear: $endYear
    )
  }
`;
